import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';

@IonicPage()
@Component({
    selector: 'file-preview',
    templateUrl: 'file-preview.html',
})
export class FilePreviewPage {

    public file: any;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public viewCtrl: ViewController,
        public sanitizer: DomSanitizer
    ) {
        this.file = this.navParams.get('file');
    }

    getUrl() {
        if (
            this.file.fileOriginal.indexOf(".doc") != -1 ||
            this.file.fileOriginal.indexOf(".xls") != -1 ||
            this.file.fileOriginal.indexOf(".ppt") != -1 ||
            this.file.fileOriginal.indexOf(".dot") != -1 ||
            this.file.fileOriginal.indexOf(".csv") != -1
        )
            return this.sanitizer.bypassSecurityTrustResourceUrl(
                "https://view.officeapps.live.com/op/embed.aspx?src=" + this.file.fileLink
            );

        if (this.file.fileOriginal.indexOf(".pdf") != -1)
            return this.sanitizer.bypassSecurityTrustResourceUrl(
                "https://docs.google.com/viewer?url=" + this.file.fileLink + "&embedded=true"
            );

        return this.sanitizer.bypassSecurityTrustResourceUrl(this.file.fileLink);
    }

    back() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/docren/file-preview.ts